// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*Cant use ng-show attribute since i have to override HideChildren class for mobile devices*/
.ShowChildren {
  display: block;
}

.HideChildren {
  display: none;
}

/*END OF*/
/*Plus Icon*/
.PlusIcon {
  top: 3px;
  position: absolute;
  height: 11px;
  width: 11px;
  display: inline-block;
  z-index: 3;
  background: var(--fi-color-white);
}
.PlusIcon:before {
  /*VERTICAL*/
  content: "";
  position: absolute;
  height: 5px;
  top: 2px;
  left: 4px;
  border-right: 1px solid var(--fi-border-color-dark);
}
.PlusIcon:after {
  /*HORIZONTAL*/
  content: "";
  position: absolute;
  width: 5px;
  left: 2px;
  top: 4px;
  border-bottom: 1px solid var(--fi-border-color-dark);
}

/*END OF Plus Icon*/
/*Minus Icon*/
.MinusIcon {
  top: 3px;
  position: absolute;
  height: 11px;
  width: 11px;
  display: inline-block;
  background: var(--fi-color-white);
  z-index: 3;
}
.MinusIcon:after {
  /*HORIZONTAL*/
  content: "";
  position: absolute;
  width: 5px;
  left: 2px;
  top: 4px;
  border-bottom: 1px solid var(--fi-border-color-dark);
}

/*END OF Minus Icon*/
/*Dotted styles*/
.ToggleDash {
  display: block;
  position: absolute;
  border-top: 1px dotted var(--fi-border-color-dark);
  width: 12px;
  left: -8px;
  top: 8px;
  z-index: 1;
}

.itemParent {
  margin-bottom: 2px;
}
.itemParent .CcmCheckBoxListChildWrap {
  position: relative;
  margin-left: 24px;
}
.itemParent .CcmCheckBoxListChildWrap .CcmCheckBoxListChildBorder {
  height: calc(100% - 10px);
  top: -5px;
  background: #ffffff;
  border-bottom: 1px solid #ffffff;
  box-sizing: border-box;
  border-left: 1px dotted var(--fi-border-color-dark);
  position: absolute;
  left: -10px;
  z-index: 2;
}

.DottedNonChildItems {
  content: "";
  border-top: 1px dotted var(--fi-border-color-dark);
  border-left: 1px solid var(--fi-color-white);
  position: absolute;
  top: 9px;
  width: 16px;
  display: inline-block;
  left: -10px;
}

/*END OF Dotted styles*/
.fi-checkbox-main {
  position: relative;
}
.fi-checkbox-main > .ToggleIcon {
  /*CheckboxList has padding: 25px for extra space*/
  margin-left: -20px;
  margin-right: 5px;
  border: 1px solid var(--fi-border-color-dark);
  border-radius: 3px;
  vertical-align: middle;
  background: var(--fi-color-white);
  cursor: pointer;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.fi-checkbox-main > .ToggleDash,
.fi-checkbox-main .DottedNonChildItems {
  position: absolute;
  top: 50%;
}

.mat-mdc-checkbox.red .mdc-form-field label {
  color: var(--fi-color-red);
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-checkbox2/fi-checkbox2.component.scss"],"names":[],"mappings":"AAAA,4FAAA;AACA;EACI,cAAA;AACJ;;AAEA;EACI,aAAA;AACJ;;AAEA,SAAA;AAEA,YAAA;AACA;EACI,QAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,qBAAA;EACA,UAAA;EACA,iCAAA;AAAJ;AAEI;EACI,WAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,mDAAA;AAAR;AAGI;EACI,aAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,QAAA;EACA,oDAAA;AADR;;AAKA,mBAAA;AAEA,aAAA;AACA;EACI,QAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,qBAAA;EACA,iCAAA;EACA,UAAA;AAHJ;AAKI;EACI,aAAA;EACA,WAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,QAAA;EACA,oDAAA;AAHR;;AAOA,oBAAA;AAEA,gBAAA;AACA;EACI,cAAA;EACA,kBAAA;EACA,kDAAA;EACA,WAAA;EACA,UAAA;EACA,QAAA;EACA,UAAA;AALJ;;AAQA;EACI,kBAAA;AALJ;AAOI;EACI,kBAAA;EACA,iBAAA;AALR;AAOQ;EACI,yBAAA;EACA,SAAA;EACA,mBAAA;EACA,gCAAA;EAGA,sBAAA;EACA,mDAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;AALZ;;AAUA;EACI,WAAA;EACA,kDAAA;EACA,4CAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,qBAAA;EACA,WAAA;AAPJ;;AAUA,uBAAA;AAEA;EACI,kBAAA;AARJ;AAUI;EACI,iDAAA;EACA,kBAAA;EACA,iBAAA;EACA,6CAAA;EACA,kBAAA;EACA,sBAAA;EACA,iCAAA;EACA,eAAA;EAEA,kBAAA;EACA,QAAA;EACA,2BAAA;AATR;AAYI;;EAEI,kBAAA;EACA,QAAA;AAVR;;AAcA;EACI,0BAAA;AAXJ","sourcesContent":["/*Cant use ng-show attribute since i have to override HideChildren class for mobile devices*/\r\n.ShowChildren {\r\n    display: block;\r\n}\r\n\r\n.HideChildren {\r\n    display: none;\r\n}\r\n\r\n/*END OF*/\r\n\r\n/*Plus Icon*/\r\n.PlusIcon {\r\n    top: 3px;\r\n    position: absolute;\r\n    height: 11px;\r\n    width: 11px;\r\n    display: inline-block;\r\n    z-index: 3;\r\n    background: var(--fi-color-white);\r\n\r\n    &:before {\r\n        /*VERTICAL*/\r\n        content: '';\r\n        position: absolute;\r\n        height: 5px;\r\n        top: 2px;\r\n        left: 4px;\r\n        border-right: 1px solid var(--fi-border-color-dark);\r\n    }\r\n\r\n    &:after {\r\n        /*HORIZONTAL*/\r\n        content: '';\r\n        position: absolute;\r\n        width: 5px;\r\n        left: 2px;\r\n        top: 4px;\r\n        border-bottom: 1px solid var(--fi-border-color-dark);\r\n    }\r\n}\r\n\r\n/*END OF Plus Icon*/\r\n\r\n/*Minus Icon*/\r\n.MinusIcon {\r\n    top: 3px;\r\n    position: absolute;\r\n    height: 11px;\r\n    width: 11px;\r\n    display: inline-block;\r\n    background: var(--fi-color-white);\r\n    z-index: 3;\r\n\r\n    &:after {\r\n        /*HORIZONTAL*/\r\n        content: '';\r\n        position: absolute;\r\n        width: 5px;\r\n        left: 2px;\r\n        top: 4px;\r\n        border-bottom: 1px solid var(--fi-border-color-dark);\r\n    }\r\n}\r\n\r\n/*END OF Minus Icon*/\r\n\r\n/*Dotted styles*/\r\n.ToggleDash {\r\n    display: block;\r\n    position: absolute;\r\n    border-top: 1px dotted var(--fi-border-color-dark);\r\n    width: 12px;\r\n    left: -8px;\r\n    top: 8px;\r\n    z-index: 1;\r\n}\r\n\r\n.itemParent {\r\n    margin-bottom: 2px;\r\n\r\n    .CcmCheckBoxListChildWrap {\r\n        position: relative;\r\n        margin-left: 24px;\r\n\r\n        .CcmCheckBoxListChildBorder {\r\n            height: calc(100% - 10px);\r\n            top: -5px;\r\n            background: #ffffff;\r\n            border-bottom: 1px solid #ffffff;\r\n            -moz-box-sizing: border-box;\r\n            -webkit-box-sizing: border-box;\r\n            box-sizing: border-box;\r\n            border-left: 1px dotted var(--fi-border-color-dark);\r\n            position: absolute;\r\n            left: -10px;\r\n            z-index: 2;\r\n        }\r\n    }\r\n}\r\n\r\n.DottedNonChildItems {\r\n    content: '';\r\n    border-top: 1px dotted var(--fi-border-color-dark);\r\n    border-left: 1px solid var(--fi-color-white);\r\n    position: absolute;\r\n    top: 9px;\r\n    width: 16px;\r\n    display: inline-block;\r\n    left: -10px;\r\n}\r\n\r\n/*END OF Dotted styles*/\r\n\r\n.fi-checkbox-main {\r\n    position: relative;\r\n\r\n    > .ToggleIcon {\r\n        /*CheckboxList has padding: 25px for extra space*/\r\n        margin-left: -20px;\r\n        margin-right: 5px;\r\n        border: 1px solid var(--fi-border-color-dark);\r\n        border-radius: 3px;\r\n        vertical-align: middle;\r\n        background: var(--fi-color-white);\r\n        cursor: pointer;\r\n\r\n        position: absolute;\r\n        top: 50%;\r\n        transform: translateY(-50%);\r\n    }\r\n\r\n    > .ToggleDash,\r\n    .DottedNonChildItems {\r\n        position: absolute;\r\n        top: 50%;\r\n    }\r\n}\r\n\r\n.mat-mdc-checkbox.red .mdc-form-field label {\r\n    color: var(--fi-color-red);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
